import {IntermediatePart} from "../../parts/intermediatePart";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {Shower} from "../../parts/shower";

export default class ShowerHead extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_head';
    this.translateId = "visualizer.bathroom.shower.shower_head";
    this.partName = 'Shower Head';
    this.layerPriority = 4;
    this.canBeDisabled = true;
    if (isChild) {
      this.previouslySelectedFeatures = {
        LG: {},
        SM: {}
      };
    }
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ShowerHead());
  }

  setLayers(layout) {

    const showerTubCombo = this.getParent().layout.parts[ShowerTubCombo.id];

    if (this.getParent().showerTubComboIsActive() && showerTubCombo && showerTubCombo.walkInTub
      && showerTubCombo.bottomTub === showerTubCombo.walkInTub.bottomTubId) {
      super.hideLayers();
      return;
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    const activeShowerPartId = showerParent.showerTubComboIsActive() ? ShowerTubCombo.id : Shower.id;
    const showerSize = showerParent.layout.parts[activeShowerPartId].showerSize();
    return [{
      propName: "Shower",
      propValue: showerParent.showerTubComboIsActive()
        ? ["Tub"]
        : showerParent.isComplete() ? "Complete" : "Custom"
    }, {
      propName: 'ShowerSize',
      propValue: showerSize
    }]
  }

  setDefault() {
    const shower = this.getParent();
    const currentActiveFeature = this.activeFeature;
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      this.setDefaultAccordingToPreviousSelect(shower, filteredFeatures, "Brantford");
    }
    this.rememberPreviousSelection(shower, currentActiveFeature);
  }

  setZIndex(zIndexes) {
    const ShowerType = this.getParent().activeSubType() === Shower.Type.Custom || this.getParent().showerTubComboIsActive()
      ? 'Custom60in'
      : 'Steam60in';
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Shower[ShowerType].ShowerHead;
    }
    if(zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndexes.Shower[ShowerType].ShowerHead;
    }
  }
}
